import React, { useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { SPAViewContext } from '@confluence/spa-view-context/entry-points/SPAViewContext';

import { ChangeEditionSectionMessage } from './ChangeEditionSectionMessage';

const i18n = defineMessages({
	siteAdminAuditLogsTitle: {
		id: 'change-edition.section.message.site-admin.audit-logs.title',
		defaultMessage: 'Upgrade for Audit logs',
		description:
			'The text is shown as the title heading in a section message component displayed on the audit logs page for site administrators. This message encourages site admins to upgrade their plan to access audit logs functionality.',
	},
	nonSiteAdminAuditLogsTitle: {
		id: 'change-edition.section.message.non-site-admin.audit-logs.title',
		defaultMessage: 'Audit logs are only available on paid plans',
		description: 'Upgrade for audit logs title for non-site admins',
	},
	siteAdminAuditLogsBody: {
		id: 'change-edition.section.message.site-admin-audit-logs.body',
		defaultMessage:
			'You’re on the free plan, so you can’t view and track changes made across your site in the audit logs. To access the audit logs, upgrade your plan.',
		description: 'Warning message explaining why the audit logs are not viewable to site admins',
	},
	nonSiteAdminAuditLogsBody: {
		id: 'change-edition.section.message.non-site-admin-audit-logs.body',
		defaultMessage:
			'You’re on the free plan, so you can’t view and track changes made across your site in the audit logs.',
		description:
			'Warning message explaining why the audit logs are not viewable to non-site admins',
	},
});

export const ChangeEditionSectionMessageAuditLogs = () => {
	const { formatMessage } = useIntl();
	const { isSiteAdmin } = useContext(SPAViewContext);

	const title = isSiteAdmin ? i18n.siteAdminAuditLogsTitle : i18n.nonSiteAdminAuditLogsTitle;
	const body = isSiteAdmin ? i18n.siteAdminAuditLogsBody : i18n.nonSiteAdminAuditLogsBody;

	return (
		<ChangeEditionSectionMessage
			title={formatMessage(title)}
			body={formatMessage(body)}
			source="auditLogs"
		/>
	);
};
